import html from './template.html'
const template = document.createElement('template')
template.innerHTML = html

class ToTop extends HTMLElement {
    /**
     * Attributes to trigger the attributeChangedCallback on.
     * @returns	{string[]}
     */
    static get observedAttributes() {
        return ['threshold', 'title']
    }

    constructor() {
        super()

        this.attachShadow({ mode: 'open' })
        this.shadowRoot.append(template.content.cloneNode(true))

        this._onScroll = this._onScroll.bind(this)
        this._onClick = this._onClick.bind(this)
    }

    /**
     * Returns the button element from the Shadow DOM.
     * @returns {HTMLButtonElement}
     */
    get button() {
        return this.shadowRoot.querySelector('button')
    }

    /**
     * Returns the span element from the Shadow DOM.
     * @returns {HTMLButtonElement}
     */
    get span() {
        return this.shadowRoot.querySelector('span')
    }

    /**
     * Gets and sets the title attribute.
     * @property
     */
    get title() {
        return this.getAttribute('title')
    }

    set title(value) {
        if ('string' === typeof value) {
            this.setAttribute('title', value)
        }
    }

    /**
     * Gets and sets the threshold attribute.
     * @property
     */
    get threshold() {
        return parseInt(this.getAttribute('threshold'))
    }

    set threshold(value) {
        const number = Number(value)
        if (!Number.isNaN(number)) {
            this.setAttribute('threshold', number)
        } else {
            this.removeAttribute('threshold')
        }
    }

    /**
     * Fires when an attribute has been changed.
     *
     * @method	attributeChangedCallback
     * @param 	{string} attrName Name of attribute.
     */
    attributeChangedCallback(attrName) {
        switch (attrName) {
            case 'threshold':
                this._onScroll()
                break
            case 'title':
                this.button.setAttribute('aria-label', this.title)
                this.span.textContent = this.title
                break
        }
    }

    /**
     * Fires when the element has been connected.
     *
     * @method	connectedCallback
     * @returns	{void}
     */
    connectedCallback() {
        window.addEventListener('scroll', this._onScroll, { passive: true })
        this.button.addEventListener('click', this._onClick)

        this.lastScrollTop =
            document.scrollingElement.scrollTop ||
            document.documentElement.scrollTop
    }

    /**
     * Fires when the element has been disconnected.
     *
     * @method	disconnectedCallback
     * @returns	{void}
     */
    disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll, { passive: true })
        this.button.addEventListener('click', this._onClick)
    }

    /**
     * Scroll event handler.
     * @return {void}
     */
    _onScroll() {
        requestAnimationFrame(() => {
            const top =
                document.scrollingElement.scrollTop ||
                document.documentElement.scrollTop

            if (top >= this.threshold) {
                if (top > this.lastScrollTop) {
                    if (this.hidden === false) {
                        this.hidden = true
                    }
                } else if (top <= this.lastScrollTop) {
                    if (this.hidden === true) {
                        this.hidden = false
                    }
                }
            } else {
                this.hidden = true
            }

            this.lastScrollTop = top
        })
    }

    /**
     * Scrollt to top on click
     *
     * @returns {void}
     */
    _onClick() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        })
    }
}

customElements.define('to-top', ToTop)



// WEBPACK FOOTER //
// ./scripts/web-components/to-top/index.js